module.exports = __webpack_public_path__ + "img/confirm-input-24.7a01eaf6.svg";